import React from 'react';

/**
 * Placeholder de carregamento (at-56, frente B).
 *
 * 🔴 **Existe para o carregamento parar de esconder o contexto.** O app tem um
 * `FullScreenLoader` que é um overlay e cobre a tela inteira — "de propósito",
 * diz o próprio componente, e para a maioria das telas isso está certo. Mas numa
 * tela de listagem com abas e busca ele apaga justamente o que o usuário precisa
 * para se situar: a spec 02 §2.7 exige que *"o carregamento não pode esconder as
 * abas nem o campo de busca — o usuário precisa manter o contexto e poder trocar
 * de aba enquanto a lista carrega"*.
 *
 * ⚠️ **Não substitui o `FullScreenLoader`**, que segue sendo o indicador de ~20
 * telas e do gate de bootstrap do `App`. Use `Skeleton` no lugar do CONTEÚDO que
 * está sendo buscado; use o loader de tela cheia quando nada pode ser tocado.
 *
 * ⚠️ `aria-hidden`: quem anuncia o carregamento é o contêiner da lista, com
 * `aria-busy` — o leitor de tela não deve ler blocos decorativos um por um.
 */

interface PropsSkeleton {
  /** Quantos blocos empilhados. Padrão 3 — o suficiente para ler como "lista". */
  linhas?: number;
  /** Altura de cada bloco (classe Tailwind). Padrão `tw-h-16`, a altura de linha. */
  altura?: string;
  className?: string;
}

const Skeleton: React.FC<PropsSkeleton> = ({
  linhas = 3,
  altura = 'tw-h-16',
  className = '',
}) => (
  <div
    className={['tw-flex tw-flex-col tw-gap-3', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  >
    {Array.from({ length: linhas }, (_, indice) => (
      <div
        key={indice}
        /* `motion-reduce` é requisito da spec 01 §7 — animação infinita é
           desconfortável para quem pediu movimento reduzido. */
        className={`${altura} tw-animate-pulse tw-rounded-xl tw-bg-superficie motion-reduce:tw-animate-none`}
      />
    ))}
  </div>
);

export default Skeleton;
